/**
 * Formatarea CANONICĂ a numărului unui document fiscal: `{SERIE}-{NR4}/{AN}`.
 *
 * O SINGURĂ sursă, folosită de cbc:ID (e-Factura), PDF-ul facturii și interfața web — ca cele trei
 * reprezentări ale aceluiași număr să NU mai difere. Înainte, cbc:ID și PDF-ul foloseau `padStart(3)`
 * („FCT-001/2026"), iar web-ul `padStart(4)` („FCT-0001/2026"); divergența devenea vizibilă deja sub
 * 1000 și se agrava peste 999 (AUDIT_RUNDA2 #30). 4 cifre = formatul implicit `{NR4}` al seriei.
 */
export function formatNumarDoc(serie, numar, an) {
    return `${serie}-${String(numar).padStart(4, '0')}/${an}`;
}
/**
 * Interpretează ce tastează operatorul când caută un document după număr, în oricare dintre
 * formele în care îl vede scris: „12", „0012", „FCT-0012", „FCT0012", „fct 12", „FCT-0012/2026".
 *
 * Căutarea făcea `numar::text LIKE '%0012%'` — dar `numar` e întreg (12), deci forma cu zerouri,
 * exact cea tipărită pe factură (`formatNumarDoc`, {NR4}), nu găsea niciodată nimic.
 * Întoarce `null` dacă termenul nu arată a număr de document.
 */
export function parseazaTermenNumarDoc(termen) {
    const m = /^\s*([A-Za-z]{1,10})?\s*[-\s]?\s*(\d{1,9})\s*(?:\/\s*(\d{4}))?\s*$/.exec(termen ?? '');
    if (!m)
        return null;
    const numar = Number.parseInt(m[2], 10);
    if (!Number.isSafeInteger(numar) || numar <= 0)
        return null;
    return {
        serie: m[1] ? m[1].toUpperCase() : null,
        numar,
        an: m[3] ? Number.parseInt(m[3], 10) : null,
    };
}
//# sourceMappingURL=numerotare.js.map